import { CognitoConfig } from "../types/config.types";

const authority_env_var = process.env.REACT_APP_COGNITO_AUTHORITY;
const client_id_env_var = process.env.REACT_APP_COGNITO_CLIENT_ID;
const redirect_uri_env_var = process.env.REACT_APP_COGNITO_REDIRECT_URI;
const cognitoDomain_env_var = process.env.REACT_APP_COGNITO_DOMAIN;
const logoutUri_env_var = process.env.REACT_APP_COGNITO_LOGOUT_URI;

if (
  !authority_env_var ||
  !client_id_env_var ||
  !redirect_uri_env_var ||
  !cognitoDomain_env_var ||
  !logoutUri_env_var
) {
  throw new Error("One or more required Cognito environment variables are not defined");
}

export const cognitoConfig: CognitoConfig = {
  authority: authority_env_var,
  client_id: client_id_env_var,
  redirect_uri: redirect_uri_env_var,
  response_type: "code",
  scope: "aws.cognito.signin.user.admin email openid phone profile",
};

export const cognitoDomain = cognitoDomain_env_var;
export const clientId = client_id_env_var;
export const logoutUri = logoutUri_env_var;
